module.exports = __webpack_public_path__ + "static/media/main5_zh.f81a4587.png";